import Clazz from '../../common/Clazz';

/**
 * 操作模块的控制器
 */
export default class OperationController extends Clazz {
    /**
     * 初始化方法
     * @method constructor
     * @param  {number} size 可记录的操作数
     * @return {undefined}
     */
    constructor(size = 30, options) {
        super(options);

        /**
         * 可记录的操作数
         */
        this.size = size;
        /**
         * 撤销操作栈
         */
        this.undoStack = [];
        /**
         * 重做操作栈
         */
        this.redoStack = [];
        /**
         * 当前（最近一次）操作
         */
        this.currentOperation = null;
    }

    /**
     * 向 undoStack 中添加本次操作结果
     * @param  {object} operation 操作结果
     * @return {undefined}
     */
    add(operation) {
        if (this.undoStack.length >= this.size) {
            this.undoStack.shift();
        }

        // 一旦有新的操作进来就清空redoStack
        this.redoStack = [];

        if (this.currentOperation) {
            this.undoStack.push(this.currentOperation);
        }
        
        this.currentOperation = operation;
    }

    /**
     * 从 undoStack 取出上一次的操作结果，向 redoStack 中添加本次操作结果
     * @return {undefined}
     */
    undo() {
        if (!this.canUndo()) {
            return;
        }

        const operation = this.undoStack.pop();

        this.redoStack.push(this.currentOperation);

        operation.undo();

        this.currentOperation = operation;
    }

    /**
     * 从 redoStack 取出上一次的操作结果，向 undoStack 中添加本次操作结果
     * @return {undefined}
     */
    redo() {
        if (!this.canRedo()) {
            return;
        }

        const operation = this.redoStack.pop();

        this.undoStack.push(this.currentOperation);

        operation.redo();

        this.currentOperation = operation;
    }

    /**
     * 判断是否可以进行 undo 操作
     * @return {boolean} 可以进行 undo 操作返回true，否侧false
     */
    canUndo() {
        return this.undoStack.length !== 0;
    }

    /**
     * 判断是否可以进行 redo 操作
     * @return {boolean} 可以进行 redo 操作返回true，否侧false
     */
    canRedo() {
        return this.redoStack.length !== 0;
    }

    /**
     * 清空 undoStack,redoStack
     * @return {undefined}
     */
    clear() {
        this.undoStack = [];
        this.redoStack = [];
        this.currentOperation = null;
    }
}
